import { useState } from 'react';
import Button from '~/components/button';
import ContainerFlex from '~/components/containerFlex';
import PasswordModal from '~/components/passwordModal';
import { useModal } from '~/hooks/useModal';
import { CompanyDataBodyRequest } from '~/services/banknow/types';
import Constants from '~/utils/constants';
import { changeCompanyStatus } from '../../actions';
import { StatusReasonContent } from './StatusReasonContent';

interface ChangeStatusModalProps {
  form: CompanyDataBodyRequest;
  onStatusChanged: (nextStatus: boolean) => void;
}

export function ChangeStatusModal({
  form,
  onStatusChanged,
}: ChangeStatusModalProps) {
  const [open, setOpen] = useState(false);
  const { openModal, closeModal } = useModal();
  const [reason, setReason] = useState('');
  const isActive = !!form.active;
  const nextStatus = !isActive;

  const openConfirmationModal = () => {
    openModal({
      title: isActive ? 'Desativar parceiro' : 'Ativar parceiro',
      message: `Deseja ${isActive ? 'desativar' : 'ativar'} o parceiro?`,
      positiveLabel: null,
      negativeLabel: null,
      negativeAction: null,
      positiveAction: null,
      children: (
        <StatusReasonContent
          confirmationWord={isActive ? 'desativar' : 'ativar'}
          placeholder={`Digite o motivo da ${
            isActive ? 'desativação' : 'ativação'
          }`}
          onConfirm={(nextReason) => {
            if (!nextReason) {
              closeModal();
              return;
            }

            setReason(nextReason);
            closeModal();
            setOpen(true);
          }}
        />
      ),
    });
  };

  const onChangeStatus = async () => {
    setOpen(false);

    try {
      const response = await changeCompanyStatus({
        idParceiro: form.companyData.id,
        ativo: nextStatus,
        motivoAtivacaoInativacao: reason,
        idUsuario: localStorage.getItem(Constants.USER_ID),
        cnpj: form?.companyData?.cnpj?.unmasked,
      });

      if (!response.success) {
        throw new Error(
          response.message || response.mensagem || 'Houve um erro',
        );
      }

      onStatusChanged(nextStatus);
      openModal({
        title: 'Sucesso',
        message: `Parceiro ${
          nextStatus ? 'ativado' : 'desativado'
        } com sucesso!`,
        widthInPercent: 30,
      });
    } catch (error) {
      openModal({
        title: `Houve um erro ao ${
          isActive ? 'desativar parceiro' : 'ativar parceiro'
        }`,
        message: error?.message ?? 'Houve um erro',
        widthInPercent: 30,
      });
    }
  };
  if (!form?.companyData?.id) return null;
  return (
    <ContainerFlex>
      <Button fitContent onClick={openConfirmationModal}>
        {isActive ? 'Desativar' : 'Ativar'}
      </Button>

      <PasswordModal
        onClose={() => setOpen(false)}
        open={open}
        onSuccessValidation={onChangeStatus}
      />
    </ContainerFlex>
  );
}
